export const COMPANY = 'company';
export const PROJECT = 'project';
export const SUPERCENTER = 'supercenter';
export const ZONE = 'zone';
